var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c(
        "el-aside",
        { attrs: { width: "230px" } },
        [
          _c(
            "el-menu",
            {
              staticStyle: { height: "100%" },
              attrs: {
                "default-openeds": ["2"],
                "default-active": "userRegistrationNew",
              },
              on: { select: _vm.handleSelect },
            },
            [
              _c(
                "el-menu-item",
                {
                  staticStyle: { "margin-top": "32px" },
                  attrs: { index: "userRegistrationNew" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "linkClass",
                      staticStyle: { "min-width": "195px" },
                      attrs: {
                        href: _vm.isCnLang
                          ? "https://api.sitcline.com:9001/workorder/用户注册.pdf"
                          : "https://api.sitcline.com:9001/workorder/User Registration.pdf",
                        target: "_blank",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-user" }),
                      _vm._v(" "),
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("helpDocuments.userRegistration"))
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("el-menu-item", { attrs: { index: "helpManual" } }, [
                _c(
                  "a",
                  {
                    staticClass: "linkClass",
                    staticStyle: { "min-width": "195px" },
                    attrs: {
                      href: _vm.isCnLang
                        ? "https://api.sitcline.com:9001/workorder/用户手册.pdf"
                        : "https://api.sitcline.com:9001/workorder/User Manual.pdf",
                      target: "_blank",
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-notebook-2" }),
                    _vm._v(" "),
                    _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                      _vm._v(_vm._s(_vm.$t("helpDocuments.helpManual"))),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-main"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }